/* ============================================
   PdfViewer — Modal PDF viewer with iframe
   Fallback: open in new tab + download buttons
   ============================================ */
import { useEffect, useCallback } from 'react'
import { IconX, IconDownload, IconExternalLink } from '@/components/icons/Icons'

interface PdfViewerProps {
  src: string
  name: string
  onClose: () => void
}

export default function PdfViewer({ src, name, onClose }: PdfViewerProps) {
  const handleKey = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') onClose()
  }, [onClose])

  useEffect(() => {
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [handleKey])

  return (
    <div className="chat-pdf-viewer" onClick={onClose}>
      <div className="chat-pdf-viewer__header" onClick={(e) => e.stopPropagation()}>
        <span className="chat-pdf-viewer__name">{name}</span>
        <div className="chat-pdf-viewer__actions">
          <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="chat-lightbox__btn"
            title="Abrir en nueva pestaña"
          >
            <IconExternalLink size={18} />
          </a>
          <a
            href={src}
            download={name}
            className="chat-lightbox__btn"
            title="Descargar"
          >
            <IconDownload size={18} />
          </a>
          <button
            className="chat-lightbox__btn"
            onClick={onClose}
            type="button"
            title="Cerrar"
          >
            <IconX size={18} />
          </button>
        </div>
      </div>
      <iframe
        src={src}
        className="chat-pdf-viewer__iframe"
        title={name}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  )
}
